export default {

    /**
     * Get var value
     * @param state
     * @returns request
     */
    var: state => (name) => {
        // Get title
        return state.vars[name];
    },

}
